export enum WIDGET_CONTRIBUTION {
    /**
     * @value Write your text here.
     */
    EDITOR_PLACEHOLDER = 'WIDGET_CONTRIBUTION.EDITOR_PLACEHOLDER',
    /**
     * @value Rich text
     */
    EMPTY_WIDGET = 'WIDGET_CONTRIBUTION.EMPTY_WIDGET',
    /**
     * @value (Click to edit)
     */
    EMPTY_WIDGET_HELPER = 'WIDGET_CONTRIBUTION.EMPTY_WIDGET_HELPER',
    /**
     * @value Double click on the widget to add content.
     */
    SETTINGS_DOUBLE_CLICK_INFO = 'WIDGET_CONTRIBUTION.SETTINGS_DOUBLE_CLICK_INFO',
}
